export default class ExistentEmailViewModel {
  get login_path() {
    return process.env.VUE_APP_COLUMBUS_WEB_LOGIN_URL;
  }
}
